import s from './separator.module.styl'
import React from 'react'

export function Separator(){
    return <span className={s.separator}></span>
}